(function () {
  function updateZeroRatingBadges() {
    document
      .querySelectorAll(
        '.jdgm-prev-badge[data-average-rating="0.00"] .jdgm-prev-badge__text'
      )
      .forEach(function (span) {
        if (span.textContent !== "Loved by Thousands") {
          span.textContent = "Loved by Thousands";
        }
      });

    // Force empty stars to appear full when score is 0.00 and reviews count is 0
    document
      .querySelectorAll(
        '.jdgm-prev-badge[data-average-rating="0.00"][data-number-of-reviews="0"] .jdgm-prev-badge__stars[data-score="0.00"]'
      )
      .forEach(function (starsEl) {
        starsEl.querySelectorAll(".jdgm-star").forEach(function (star) {
          star.classList.remove(
            "jdgm-star--empty",
            "jdgm-star--half",
            "jdgm-star--plain",
            "jdgm-star--off"
          );
          star.classList.add("jdgm-star--on");
          // Replace empty star character with filled star if present
          if (star.textContent.trim() === "\u2606") {
            star.textContent = "\u2605";
          }
        });
      });
  }
  var badgeObserver = new MutationObserver(updateZeroRatingBadges);
  badgeObserver.observe(document.body, { childList: true, subtree: true });
  document.addEventListener("DOMContentLoaded", updateZeroRatingBadges);
})();
